import config from '../config';

export const getDashboardURL = () => `${config.APP_URL}${config.APP_PATH}`;

/*
 * Matches a url slug against providers object and 
 * returns an object with the current provider info
 */
export const getProvider = (providers) => {
  const providerInfo = getSlug(window.location.href, providers);

  return providerInfo.length ? (
    providers.filter(provider => provider.slug === providerInfo[0].slug)[0]
  ) : ({});
}

/*
 * Parse the path segments of a URL and return
 * the last segment as the URL slug.
 */
export const getSlug = (url, providers) => {
  const tempLink = document.createElement('a');
  tempLink.setAttribute('href', url);
  const pathSegments = tempLink.pathname.replace(/^\//, '').split('/');
  const slug = providers.filter(provider => pathSegments.includes(provider.slug))
  return slug;
}

/*
 * Opens provider url in a new tab and switches to it
 */
export const openInNewTab = (url) => {
  var win = window.open(url, '_blank');
  win.focus();
}